let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dviIw"), load("kBLei")]).then(() => parcelRequire('b9VQF'));